<template>
  <p>You are about to delete you account.</p>
  <ul>
    <li>You will no longer be able to log in to GOFAR with this account.</li>
    <li>All of the data associated with that accont will be deleted permanently, including your mileage logging.</li>
    <li>You will not receive a refund for your ongoing subscriptions.</li>
  </ul>
  <p><strong>This cannot be undone.</strong> Please be ensure you are deleting the correct account.</p>
  <div class="row g-3">
    <div class="col-md-4 col-sm-6">
      <label for="inputPassword3" class="col-form-label">Confirm by typing DELETE</label>
    </div>
    <div class="col-md-4 col-sm-6">
      <input
        type="text"
        class="form-control"
        id="inputPassword3"
        v-model="confirmationText"
        placeholder="Confirm By typing DELETE"
      />
    </div>
    <div class="col-sm">
      <button
        type="button"
        class="btn btn-danger"
        data-bs-toggle="modal"
        data-bs-target="#accountDeleteConfirmation"
        :disabled="confirmationText != 'DELETE'"
      >
        Delete
      </button>
    </div>
  </div>
  <div
    class="modal fade"
    id="accountDeleteConfirmation"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="accountDeleteConfirmationLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="accountDeleteConfirmationLabel">Confirmation</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>
            Your account deletion process has been started. It can take us up to <strong>30 days</strong> to delete and
            you will not be able to access your account during this time.
          </p>
          <p>If this action was not intended or you changed your mind, contact us immediately at support@gofar.co</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" @click="requestAccountDelete">DELETE</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiClient } from '../helpers/api-client';
import { HTTP_METHODS, HTTP_STATUS_CODES } from '../helpers/config';
const localStorageHelper = require('../helpers/local-storage');

export default {
  name: 'DeleteAccount',
  data() {
    return {
      confirmationText: ''
    };
  },
  methods: {
    async requestAccountDelete() {
      const user = localStorageHelper.getLoggedInUser();
      const result = await apiClient(`users/${user.userId}/deleteaccount`, HTTP_METHODS.POST);
      if (result.status === HTTP_STATUS_CODES.NO_CONTENT) {
        $('#accountDeleteConfirmation').modal('hide');
        localStorageHelper.clearLocalStorage();
        this.$router.push({ path: '/login' });
      }
    }
  }
};
</script>
